import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Estábamos al borde de la separación. Las discusiones eran diarias. Este manual nos dio las palabras que no encontrábamos para decirnos lo que realmente nos dolía. Hoy estamos más unidos que cuando nos conocimos.',
  author: 'Martina y Lucas',
  role: '7 años juntos'
}, {
  quote: 'Lo leí yo sola primero. Empecé a cambiar mi forma de reaccionar usando las herramientas del libro, y automáticamente él empezó a cambiar también. Es increíble cómo romper el patrón de uno, cambia la dinámica entera.',
  author: 'Sofía',
  role: 'Lectura individual'
}, {
  quote: 'Pensé que era otro libro de autoayuda genérico, pero los ejercicios prácticos nos obligaron a mirarnos a los ojos y hablar de cosas que veníamos evadiendo hace años. Nos salvó.',
  author: 'Diego',
  role: '12 años de casados'
}];
export function TestimonialsSection() {
  return <Section background="secondary" data-id="element-187">
      <div className="text-center mb-16" data-id="element-188">
        <span className="text-accent font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-189">
          Historias Reales
        </span>
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-190">
          Parejas que eligieron transformarse
        </h2>
        <div className="w-16 h-1 bg-accent mx-auto rounded-full" data-id="element-191" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-192">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-navy-700 rounded-xl p-8 border border-navy-border flex flex-col relative" data-id="element-193">
            <Quote className="absolute top-6 right-6 text-navy-800 w-12 h-12" data-id="element-194" />

            <div className="flex gap-1 mb-6 text-accent relative z-10" data-id="element-195">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-196" />)}
            </div>

            <p className="text-gray-300 italic mb-8 flex-grow leading-relaxed relative z-10" data-id="element-197">
              "{t.quote}"
            </p>

            <div className="pt-6 border-t border-navy-border relative z-10" data-id="element-198">
              <p className="font-bold text-white" data-id="element-199">{t.author}</p>
              <p className="text-sm text-accent" data-id="element-200">{t.role}</p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}